import en from './en.json';
import fr from './fr.json';

// Intentionally not widened to `Record<string, unknown>` — keeping the precise literal type
// inferred from the JSON imports is what lets `createI18n({ messages: crmMessages })` resolve its
// `Locales` generic from the `en`/`fr` keys; a wider annotation here breaks that inference and
// forces `createI18n`'s overload resolution to fall through to its `'en-US'`-defaulting overload.
export const crmMessages = {
    en,
    fr,
};
